import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const LinkIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.6566 6.34317C16.4849 5.17151 14.5857 5.17141 13.4142 6.3429L12 7.75711C11.6095 8.14763 10.9763 8.14763 10.5858 7.75711C10.1953 7.36658 10.1953 6.73342 10.5858 6.3429L12 4.92868C13.9527 2.97597 17.1182 2.97643 19.0708 4.92896C21.0234 6.88161 21.0233 10.0475 19.0707 12.0001L17.6574 13.414C17.267 13.8047 16.6338 13.8048 16.2432 13.4144C15.8526 13.024 15.8524 12.3908 16.2428 12.0002L17.6563 10.586L17.6565 10.5858C18.8281 9.41424 18.8281 7.51472 17.6566 6.34317ZM15.5358 8.46482C15.9263 8.85534 15.9263 9.4885 15.5358 9.87903L9.87891 15.5359C9.48838 15.9264 8.85522 15.9264 8.46469 15.5359C8.07417 15.1454 8.07417 14.5122 8.46469 14.1217L14.1215 8.46482C14.5121 8.07429 15.1452 8.07429 15.5358 8.46482ZM7.75796 10.5859C8.14849 10.9764 8.14849 11.6096 7.75796 12.0001L6.34375 13.4143C5.17203 14.5861 5.17187 16.4857 6.3433 17.6572C7.51461 18.8285 9.41461 18.8284 10.5864 17.657C10.5865 17.6569 10.5866 17.6568 10.5867 17.6567L11.9991 16.243C12.3894 15.8523 13.0226 15.852 13.4133 16.2423C13.804 16.6326 13.8043 17.2658 13.4139 17.6565L12.0012 19.0706L12.0009 19.0709C10.0484 21.0234 6.88185 21.0241 4.92908 19.0714C2.97631 17.1186 2.97706 13.9526 4.92954 12.0001L6.34375 10.5859C6.73427 10.1954 7.36744 10.1954 7.75796 10.5859Z'
        fill={color}
      />
    </svg>
  )
})
